//--------------------------------------------------------------------------------------------------------------------------------------------
 var axios = require("axios")
// var MockAdapter = require("axios-mock-adapter")

// if(process.env.NODE_ENV==="development"){
//     console.log("process.env.NODE_ENV--------------------",process.env.NODE_ENV)
//     axios.defaults.baseURL = '//community.hxddz.syyx.com/'
//     axios.defaults.withCredentials = false
// }

//--------------------------------------------------------------------------------------------------------------------------------------------

var _init = function (self, method, url, mdata) {
    if (!self.opt) return

    if (!self.ma) {
        self.ma = new MockAdapter(axios, {
            delayResponse: self.opt.delay || 500
        })
    }

    var on_methods = {
        'get': 'onGet',
        'post': 'onPost'
    }

    var onfn = on_methods[method]
    var fn = self.ma[onfn]

    fn.call(self.ma, url).reply(200, mdata)
}

//--------------------------------------------------------------------------------------------------------------------------------------------
var _get = function (url, params, cb, mdata, config) {
    if (typeof params == 'function') {
        mdata = cb
        cb = params
        params = null
    }

    var self = this
    _init(self, 'get', url, mdata)

    axios.get(url, {
            params
        }, config)
        .then(res => cb(0, res.data))
        .catch(err => cb(err))
}
//--------------------------------------------------------------------------------------------------------------------------------------------
var _post = function (url, params, cb, mdata, config) {
    if (typeof params == 'function') {
        mdata = cb
        cb = params
        params = null
    }

    var self = this
    _init(self, 'post', url, mdata)

    axios.post(url, params, config)
        .then(res => cb(0, res.data))
        .catch(err => cb(err))
}
//--------------------------------------------------------------------------------------------------------------------------------------------
exports.init = function (options, mdata) {
    // mdata { 'url' : { method : 'get', status : 200, value : {...}, fn : function(c) { ... } } }
/*
    if (options && mdata) {
        var ma = new MockAdapter(axios, {
            delayResponse: options.delay || 500
        })
        var on_methods = {
            'get': 'onGet',
            'post': 'onPost'
        }

        for (var url in mdata) {
            var d = mdata[url]

            var onfn = on_methods[d.method]
            var fn = ma[onfn]

            if (d.status) {
                fn.call(ma, url).reply(d.status, d.value)
            } else if (d.fn) {
                fn.call(ma, url).reply(d.fn)
            }
        }
    }
*/
    var get = _get, post = _post

    return {
        opt: options,
        // mdata: mdata,
        // ma: ma || null,
        get  : get,
        post : post,
    }
}
//--------------------------------------------------------------------------------------------------------------------------------------------